interface ViewPort {
    width: number,
    height: number,
}

function isTouchDevice(): boolean {
    // noinspection JSUnresolvedReference
    return 'ontouchstart' in window || (<any>window).DocumentTouch && document instanceof (<any>window).DocumentTouch;
}

// Replaces deprecated jQuery .isNumeric(), see https://stackoverflow.com/a/9716488/94289
function isNumeric(n: any): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * See https://stackoverflow.com/a/11310353
 *
 */
function getViewport(): ViewPort {
    let e = <any>window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';

        e = document.documentElement || document.body;
    }
    return {width: e[a + 'Width'], height: e[a + 'Height']};
}


function isLargeScreen(minLargeScreenWidth: number = 1200): boolean {
    const viewport = getViewport();
    return viewport.width >= minLargeScreenWidth;
}

/**
 * See https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
 */
function isElementInViewport(element: HTMLElement): boolean {
    const viewport = getViewport();
    const rect = element.getBoundingClientRect();
    return (
        Math.floor(rect.top) >= 0 &&
        Math.floor(rect.left) >= 0 &&
        Math.floor(rect.bottom) <= viewport.height &&
        Math.floor(rect.right) <= viewport.width
    );
}

export {isTouchDevice, isNumeric, isLargeScreen, getViewport, isElementInViewport};